<template>
    <div :class="['page take-survey',{ off: !pageOn }]"> 
        <VHeader type="back" @back="back" />
        <div class="page-content" :style="{ backgroundColor: backgroundColor }">
            <div class="page-container">
                <div v-for="page in survey" style="width: 100%" :class="['survey-page',{ off: page.off }]" :key="page.code" :id="'id-'+page.code">
                    <img :src="page.background" style="width: 100%" />
                    <div class="btns" :style="btnsStyle">
                        <div v-for="btn in page.btns"> 
                            <div :class="['btn',btn.type]" @click="action(page,btn)" v-if="!btn.content.textarea" :style="btn.content.style+';font-size:28px;'+( page.styleButton ? (';background-color:'+campaign.buttonColor+';color:'+campaign.buttonFontColor) : '')">
                                <p style="position: absolute;opacity: 0;color:black">btn.type {{ btn.type }}</p>
                                <img v-if="btn.type == 'image'" style="width: 100%;" :src="btn.content.value" />
                                <img v-if="btn.type == 'quiz-result'" style="width: 100%;" :src="btn.content.img" />                                     
                                <!-- <img v-if="btn.type == 'qr'" src="https://api.survey-vip.com/qr?id=somerandomedata" /> -->
                                <video :id="btn.code" v-if="btn.type == 'video'"  :src="btn.content.mov"  controls="true" width="100%" height="100%"></video>
                                <div v-if="btn.type == 'slider'">
                                    <p id="points">{{ btn.content.init }}</p>
                                    <input type="range" v-model="btn.content.init" :id="'code-'+btn.code" :step="btn.content.step" :min="btn.content.min" :max="btn.content.max" />
                                </div>
                                <img v-if="btn.type == 'gif'" :src="btn.content.gif" style="width: 100%;" />
                                <div v-if="btn.type == 'checkbox'">
                                    <input type="checkbox" style="width:100% !important;height:100%;opacity:0;position: absolute;z-index: 10;top:0px;left:0px" />
                                    <img :src="btn.content.background" style="position: absolute;top:0px;left:0px;z-index: 0;" />
                                </div>
                                <div v-if="btn.html" v-html="btn.html"></div>  
                            </div>
                            <textarea v-if="btn.content.textarea" :placeholder="btn.content.placeholder" :id="'code-'+btn.code" class="btn" :style="btn.content.style+';font-size:20px;text-align:left;color:black'+(btn.content.border ? ( ';border: 1px solid '+btn.content.borderColor ) : '')"></textarea>
                        </div>
                    </div>  
                </div>  
            </div>


        </div>

    </div> 
    </div>
</template>

<script>

import VHeader from '@/components/VHeader.vue'
import { pageOn } from '@/utils/pageOn.js'
import { mapActions, mapMutations } from 'vuex'
import WebSoc from '@/utils/WebSoc.js'
import Ham from '@/components/Ham.vue'

export default {
    name: 'take-survey',
    mixins: [ pageOn ],
    components: {
        VHeader,
        Ham
    },
    computed: {
        survey () { return this.$store.state.takeSurvey },
        customer_id () { return this.$store.state.auth._id },
        client_id () { return this.$store.state.client_id },
        customerID () { return this.$store.state.auth.id },
        btnColor () { return this.$store.state.btnColor },
        btnFontColor () { return this.$store.state.btnFontColor },
        ads () { return this.$store.state.ads },
        adCats () { return this.$store.state.adCats },
        selectedCat () { return this.$store.state.selectedCat },
        backgroundColor () { return this.$store.state.backgroundColor },
        response_id () { return this.$store.state.response_id },
        campaign_id () { return this.$store.state.campaign_id }
    },
    data () {
        return {
            btnsStyle: '',
            date: Date.now(),
            rangeInputs: {},
            pageContent: {},
            surveyDB: false,
            scorePage: false,
            scoreBtn: false
        }
    },
    mounted () {
        this.surveyDB = this.campaign_id+'-responses';
        //console.log('this.survey',JSON.parse(JSON.stringify(this.survey)));
        var width = parseInt(getComputedStyle(this.$el.querySelector('.page-content')).width);
        this.btnsStyle = 'transform: scale('+(width / 414)+')';
        this.pageContent = this.$el.querySelector('.page-container');
        this.scorePage = this.survey.find(p => p.btns.find(b => b.type == 'slider-score') );
        this.scoreBtn = this.scorePage && this.scorePage.btns.find(b => b.type == 'slider-score');
        this.scoreBtn && ( this.scoreBtn.value = 0 );
    },
    methods: {
        action ( page, btn ) {
            switch ( btn.type ) {
                case 'next':
                    var nextPage = this.survey[this.survey.indexOf(page)+1]
                    nextPage && this.setItemKeyValue({ item: nextPage, k: 'off', v: false });
                    this.sendNextData(page,btn);
                    nextPage && this.checkNext(nextPage,btn);
                    if ( !nextPage ) { return this.pageOn = false; }
                    this.pageContent.scrollTop = 0;
                    break;
                case 'step':
                    var stepPage = this.survey.find(p => p.field == btn.page);
                    stepPage && this.setItemKeyValue({ item: stepPage, k: 'off', v: false });
                    this.pageContent.scrollTop = 0;
                    break;
                default:
                console.log('acion?',btn.type,JSON.parse(JSON.stringify(btn)));
            }
           
        },
        back () {
            this.pageContent.scrollTop = 0;
            var currentIndex = this.survey.reduce((p,page,i) => page.off ? p : i,0);
            if ( currentIndex == 0 ) { return this.pageOn = false; }
            this.setItemKeyValue({ item: this.survey[currentIndex], k: 'off', v: true })
        },
        sendNextData ( page, btn ) {
            this.pageContent.scrollTop = 0;
            var surveyDB = this.surveyDB;
            var response_id = this.response_id;
            
            var currentPage = this.$el.querySelector('.survey-page#id-'+page.code);
            var textarea = [].slice.call(currentPage.querySelectorAll('textarea')).reduce((p,inp) => p.concat(inp.id.split('-')[1]+'='+inp.value),[])
            var rangeInput = [].slice.call(currentPage.querySelectorAll('input[type=range]')).reduce((p,inp) => { 
                var val = parseInt(inp.value);
                if ( isNaN(val) ) return;
                var code = inp.id.split('-')[1];
                this.rangeInputs[code] = val;
                return p.concat(code+'='+val); 
            },[])
            if ( textarea.length > 0 ) {
                return console.log('textarea data',textarea);
            }
            if ( rangeInput.length > 0 ) {
                var resp = rangeInput.reduce((p,inp) => { var val = inp.split('='); p[val[0]] = val[1]; return p; },{})
                return WebSoc.SEND({ t: 'nextPage', data: { surveyDB, response_id, resp: resp } },resp => {
                    console.log('nextPage',resp);
                })
            }
            
            if ( btn.content.value == '' ) return;

            var value = parseInt(btn.content.value);
            
            if ( value < 11 && !isNaN(value) ) { this.rangeInputs[page.code] = value; }
            WebSoc.SEND({ t: 'nextPage', data: { surveyDB, response_id, resp: { [page.code]: btn.content.value } } },resp => {
                console.log('nextPage resp',resp);
            });
        },
        checkNext ( page, btn ) {
            var nextPage = this.$el.querySelector('.survey-page#id-'+page.code);
            var sliderScore = nextPage.querySelector('.slider-score');
            var response_id = this.response_id;
            var surveyDB = this.surveyDB;
            if ( this.scoreBtn ) {
                var value = Object.keys(this.rangeInputs).reduce((p,key) => p += this.rangeInputs[key],0);
                WebSoc.SEND({ t: 'nextPage', data: { surveyDB, response_id, resp: { [this.scorePage.code]: value }}},resp => {
                    console.log('checkNext resp',resp);
                });
            }
            if ( sliderScore ) {
                WebSoc.SEND({ t: 'nextPage', data: { surveyDB, response_id, resp: { complete: true }}},resp => {
                    console.log('resp.complete',true);
                });
                var height = sliderScore.style.height;
                sliderScore.innerHTML =  `<p style="margin:0px;text-align:center;font-size:${height};line-height:${height}">${value}</p>`;
                this.getScore();
            }
        },
        send ( msg ) {
            function send(msg,cB) {
                    console.log('send',msg);
                    var x = new XMLHttpRequest();
                        x.onreadystatechange = function() { x.readyState == 4 && x.status == 200 && x.responseText && ( typeof cB == 'function' ? cB(JSON.parse(x.responseText)) : checkResponse(x.responseText) ) }
                        x.open('GET','https://survey-vip.com/msg?path='+path+'&'+msg);
                        x.send();		    
                }

                function checkResponse(resp) {
                    
                    resp = JSON.parse(resp);
                    
                    if ( resp.Redeemed ) return updateRedeemed(resp);

                    resp.user_id && ( user_id = resp.user_id );
                    resp.survey_id && ( survey_id = resp.survey_id );
                    resp.surveyID && ( surveyID = resp.surveyID );

                    typeof user_id != 'undefined' && survey_id && ( path = 'started-'+Date.now()+'&surveyID='+surveyID+'&survey_id='+survey_id+'&user_id='+user_id );
                    
                    if ( resp.surveyDB ) { path += '&surveyDB='+resp.surveyDB; }
                    
                    resp.userID && ( path = resp.userID )

                    if ( user_id && survey_id && query.starCode && !query.starred ) { 
                        query.starred = true;
                        setTimeout(function() {
                            send('m='+encodeURIComponent(query.starCode+'='+query.resp)); 
                        },1000);
                    }
                }
        },
        ...mapMutations([
            'setPages',
            'pushPage',
            'setKeyValue',
            'setValue',
            'setItemKeyValue'
        ]),
        ...mapActions([
            'getScore'
        ])
    }
}

</script>

<style lang="scss">
.take-survey {
    .survey-page {
        position: absolute;
        top: 0px;
        left: 0px;
        transition: transform 0.3s;
        /* transition: left 0.3s; */
        &.off {
            /* left: 100%; */
            transform: translateX(100%);
        }
        &:last-child {
            margin-bottom: 0px;
        }
    }
    .page-container {
        width: 100%;
        height: 100%;
        position: fixed;
        overflow-y: scroll;
        overflow-x: hidden;
    }
    .btns {
        position: absolute;
        top: 0px;
        left: 0px;
        .btn {
            position: absolute;
        }
        #points { text-align: center; font-size: 40px; }
    }
}    
.page.survey {
    .page-content {
        background-color: white;
        height: calc(100% - 40px);
        overflow-x: hidden;
        .ad-img:last-child {
            .loyalty-ad-container {
                margin-bottom: 200px;
            }
        }
    }
}    
div.loyalty-ad-container {
    position: relative;
    transition: transform 1s;
    -webkit-perspective: 1000;
    transform-style: preserve-3d;
    perspective: 1000;
    -webkit-transform:translate3d(0,0,0);
    float: left;
    width: calc(100% - 10px);
    margin: 5px 0px 0px 5px;
    img.sizer {
        width: 100%;
        margin: 0px;
        z-index: -1;
        opacity: 0;
    }
    .front-box,.back-box {
        float: left;
        opacity: 1;
        position: absolute;
        width: 100%;
        margin: 0px;
        top: 0px;
        left: 0px;
        backface-visibility: hidden;
        -webkit-transform:translate3d(0,0,0);
        transform-style: preserve-3d;
        perspective: 1000;
    }
    .front-box {
        z-index: 2;
    }
    .back-box {
        z-index: 1;
        transform: rotateY(180deg);
        position: absolute;
        left: 0px;
    }
    &.rotate {
        transform: rotateY(180deg);
    }
    img.loyalty-ad {
        width: 100%;
        position: absolute;
        box-shadow: 0px 0px 17px 0px rgba(0,0,0,0.6);
    }
    .btns {
        position: absolute;
        top: 0px;
        left: 0px;
        transform-origin: 0px 0px;
        .btn { position: absolute; background-color: rgba(200,0,200,0); &:active { transform: translate(0px,0px) } }
        .type-qr img { width: 100%; }
        .type-link a { position: absolute; width: 100%; height: 100%; }
    }
}
</style>